module.exports = __webpack_public_path__ + "static/media/ac4.02ecfc83.jpg";